import envConfig from "../../config/envConfig";

export const schoolRegisterSuccess = ({ schoolName, emailId, parentRegistrationLink, schoolFee }) => {
  const subject =
    "Welcome to Practido - Olympiad Practice App! Your Registration is Successful";
  const googlePlayLink = envConfig.googlePlayLink || "#";
  const appStoreLink = envConfig.appStoreLink || "#";
  const schoolFeeAmount = Number(schoolFee) || 0;
  const totalAmount = 99 + schoolFeeAmount;
  const emailBody = `
<p>Dear <strong>${schoolName}</strong>,</p>

<p>We are delighted to welcome you to <strong>Practido – Olympiad Practice App</strong>!<br>
Your school’s registration has been successfully completed, and you are now part of a growing community helping students practice more and achieve more.</p>

<p><strong>School Registration Details</strong><br>
School Name: <strong>${schoolName}</strong><br>
Registered Email: <strong>${emailId}</strong></p>

<p><strong>Next Step for Parents & Students</strong><br>
Share this link with parents and students for registration:<br>
👉 <a href="${parentRegistrationLink}" target="_blank" rel="noopener noreferrer">${parentRegistrationLink || 'Parent Registration Link'}</a>
</p>

<p><strong>Special Academic Year Offer (One-time fee for this academic year):</strong><br>
Total amount paid by per Parent/Student - <strong>₹${totalAmount}</strong><br>
Practido’s keep: <strong>₹99</strong> (per student)<br>
School’s keep: <strong>₹${schoolFeeAmount}</strong> (per student)
</p>

<p><strong>Why Practido?</strong></p>
<ul>
  <li>Unlimited practice questions in Math, Science, English & Computers (Classes 1–8).</li>
  <li>Instant results with detailed progress tracking.</li>
  <li>Gamified learning – challenges with friends, community practice, and rewards.</li>
  <li>No waiting for the next book – just practice anytime, anywhere.</li>
  <li>10,000+ students already using it | 4.5★ rating on Play Store.</li>
  </ul>

<p><strong>Download Practido App</strong><br>
Android: <a href="${googlePlayLink}" target="_blank" rel="noopener noreferrer">Google Play Link</a><br>
iOS: <a href="${appStoreLink}" target="_blank" rel="noopener noreferrer">App Store Link</a>
</p>

<p><strong>Need Help?</strong><br>
📞 Call/WhatsApp: +91 9560734660<br>
✉️ Email: <a href="mailto:hello@practido.com">hello@practido.com</a>
</p>

<p>Thank you for partnering with us to make Olympiad practice engaging and effective.<br>
We look forward to seeing the next Olympiad topper from your school!</p>

<p><strong>Follow us on social media:</strong><br>
Facebook: <a href="https://www.facebook.com/profile.php?id=100094743883639" target="_blank" rel="noopener noreferrer">facebook.com/profile.php?id=100094743883639</a><br>
Twitter: <a href="https://twitter.com/olympiad_p" target="_blank" rel="noopener noreferrer">twitter.com/olympiad_p</a><br>
Instagram: <a href="https://www.instagram.com/olympiadpracticeapp" target="_blank" rel="noopener noreferrer">instagram.com/olympiadpracticeapp</a>
</p>
`;

  return { subject, emailBody };
};
